import { getSettingsItem } from './settingsSelectors'

export const getEmailSettings = (state) => {
  return getSettingsItem(state).email || {}
}

export const isShowEmailBranding = (state) => {
  const emailSettings = getEmailSettings(state)
  return !!emailSettings.show_email_branding
}

export const hasCompletedCompanyData = (state) => {
  const emailSettings = getEmailSettings(state)
  const { address, company_name } = emailSettings
  return !!address && !!company_name
}
